<h2 mat-dialog-title style="margin: 0">{{'inspectionReportEditTextDialog.MsgEditRptText' | translate}}</h2>
<div *ngIf="!isSafari(browserName)" fxLayout="row wrap" fxLayoutAlign="end" fxLayoutGap="10px">
  <mat-form-field class="file-type-input">
    <input matInput placeholder="{{'inspectionReportEditTextDialog.FileType' | translate}}" value="xlsx" disabled>
  </mat-form-field>
  <div fxLayoutGap="10px">
    <mat-dialog-actions class="import-button">
      <button mat-raised-button color="primary" (click)="useApplicationFileManager ? showFileManager() : importButton.click();" [disabled]="!isEditableItems || isValueChange  || !this.isWebAndDesktopOnline">
        {{'inspectionReportEditTextDialog.Import' | translate}}
      </button>
      <input hidden #importButton type="file" accept=".xlsx" [(ngModel)]="importFiles" (change)="importInspectionReportEditabelTexts($event.target.files); importButton.value=''" />
    </mat-dialog-actions>
  </div>
</div>
<!---->
<mat-dialog-content class="editable-dialog-container">
  <mat-sidenav-container class="editabletext-menu-container">
    <mat-sidenav mode="side" opened class="editabletext-menu-sidenav">
      <div class="checked-sections">
        {{'inspectionReportEditTextDialog.CheckedSections' | translate}}
      </div>
      <ng-container *ngFor="let inputGroup of inputGroups">
        <mat-nav-list class="editabletext-sidenavi" fxLayout="column" fxLayoutAlign="center center">
          <div class="sidenavi-navigation">
            <div class="sidenavi-itemLink-div">
              <mat-checkbox [(ngModel)]="inputGroup.isSelected" fxLayout="row wrap" (change)="onCheckBoxChange()"/>
              <a class="sidenavi-itemLink" [class.inputGroupSelected]="inputGroupName === inputGroup.name" fxLayout="row" (click)="getTabItem(inputGroup.name)">
                <mat-icon *ngIf="isRequiredNotInput(inputGroup.name, reportEditableTexts)" class="tab-icon">warning</mat-icon>
                <span class="sidenavi-navText" [matTooltip]="inputGroup.name">{{ inputGroup.name }}</span>
              </a>
            </div>
          </div>
        </mat-nav-list>
      </ng-container>
    </mat-sidenav>
    <mat-sidenav-content #sidenavcontent class="editabletext-menu-content">
      <div #edittextcontent class="form-container" name="edit" fxLayout="column" fxLayoutAlign="start" fxLayoutGap="10px">
        <div *ngFor="let item of inputGroupLists[inputGroupName]">
          <ng-container [ngSwitch]="item.inputType">
            <ng-container *ngIf="item.validation.required">
              <mat-form-field *ngSwitchCase="'text'" class="text-select-form">
                <mat-label class="top-label">{{ item.label }}</mat-label>
                <input matInput maxlength="{{item.validation.maxLength}}" required [(ngModel)]="reportEditableTexts[item.editableId]"
                       name="{{item.editalbeId}}" [errorStateMatcher]="matcher" value="{{reportEditableTexts[item.editableId]}}"
                       ngDefaultControl (focusout)="copyValue(item.editableId,reportEditableTexts[item.editableId]);$event.stopPropagation();">
                <mat-hint align="end">
                  {{ reportEditableTexts[item.editableId]?.length || 0 }}/{{ item.validation.maxLength }}
                </mat-hint>
                <mat-hint align="start" *ngIf="reportEditableTexts[item.editableId]?.length > item.validation.maxLength">
                  <font color="red">{{'inspectionReportEditTextDialog.ErrOverMaxLength' | translate}}</font>
                </mat-hint>
                <mat-hint align="start" *ngIf="reportEditableTexts[item.editableId]?.length === 0 || reportEditableTexts[item.editableId]?.length === null">
                  <font color="red">{{'inspectionReportEditTextDialog.ErrReq' | translate}}</font>
                </mat-hint>
              </mat-form-field>
            </ng-container>

            <ng-container *ngIf="!item.validation.required">
              <mat-form-field *ngSwitchCase="'text'" class="text-select-form">
                <mat-label class="top-label">{{ item.label }}</mat-label>
                <input matInput maxlength="{{item.validation.maxLength}}" [(ngModel)]="reportEditableTexts[item.editableId]"
                       name="{{item.editableId}}" [errorStateMatcher]="matcher" value="{{reportEditableTexts[item.editableId]}}"
                       ngDefaultControl (focusout)="copyValue(item.editableId,reportEditableTexts[item.editableId]);$event.stopPropagation();">
                <mat-hint align="end">
                  {{ reportEditableTexts[item.editableId]?.length || 0 }}/{{ item.validation.maxLength }}
                </mat-hint>
                <mat-hint align="start" *ngIf="reportEditableTexts[item.editableId]?.length > item.validation.maxLength">
                  <font color="red">{{'inspectionReportEditTextDialog.ErrOverMaxLength' | translate}}</font>
                </mat-hint>
              </mat-form-field>
            </ng-container>

            <ng-container *ngIf="!isSafari(browserName)">
              <ng-container *ngIf="item.validation.required">
                <mat-form-field *ngSwitchCase="'textArea'" class="text-select-form">
                  <mat-label class="top-label">{{ item.label }}</mat-label>
                  <textarea matInput maxlength="{{item.validation.maxLength}}" matTextareaAutosize required [(ngModel)]="reportEditableTexts[item.editableId]"
                            name="{{item.editableId}}" [errorStateMatcher]="matcher" value="{{reportEditableTexts[item.editableId]}}"
                            ngDefaultControl (focusout)="copyValue(item.editableId,reportEditableTexts[item.editableId]);$event.stopPropagation();"></textarea>
                  <mat-hint align="end">
                    {{ reportEditableTexts[item.editableId]?.length || 0 }}/{{ item.validation.maxLength }}
                  </mat-hint>
                  <mat-hint align="start" *ngIf="reportEditableTexts[item.editableId]?.length > item.validation.maxLength">
                    <font color="red">{{'inspectionReportEditTextDialog.ErrOverMaxLength' | translate}}</font>
                  </mat-hint>
                  <mat-hint align="start" *ngIf="reportEditableTexts[item.editableId]?.length === 0 || reportEditableTexts[item.editableId]?.length === null">
                    <font color="red">{{'inspectionReportEditTextDialog.ErrReq' | translate}}</font>
                  </mat-hint>
                </mat-form-field>
              </ng-container>

              <ng-container *ngIf="!item.validation.required">
                <mat-form-field *ngSwitchCase="'textArea'" class="text-select-form">
                  <mat-label class="top-label">{{ item.label }}</mat-label>
                  <textarea matInput maxlength="{{item.validation.maxLength}}" matTextareaAutosize [(ngModel)]="reportEditableTexts[item.editableId]"
                            name="{{item.editableId}}" [errorStateMatcher]="matcher" value="{{reportEditableTexts[item.editableId]}}"
                            ngDefaultControl (focusout)="copyValue(item.editableId,reportEditableTexts[item.editableId]);$event.stopPropagation();"></textarea>
                  <mat-hint align="end">
                    {{ reportEditableTexts[item.editableId]?.length || 0 }}/{{ item.validation.maxLength }}
                  </mat-hint>
                  <mat-hint align="start" *ngIf="reportEditableTexts[item.editableId]?.length > item.validation.maxLength">
                    <font color="red">{{'inspectionReportEditTextDialog.ErrOverMaxLength' | translate}}</font>
                  </mat-hint>
                </mat-form-field>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="isSafari(browserName)">
              <ng-container *ngIf="item.validation.required">
                <mat-form-field *ngSwitchCase="'textArea'" class="text-select-form">
                  <mat-label class="top-label">{{ item.label }}</mat-label>
                  <textarea matInput maxlength="{{item.validation.maxLength}}" matTextareaAutosize matAutosizeMinRows=1
                            matAutosizeMaxRows=5 required [(ngModel)]="reportEditableTexts[item.editableId]" name="{{item.editableId}}"
                            [errorStateMatcher]="matcher" value="{{reportEditableTexts[item.editableId]}}"
                            ngDefaultControl (focusout)="copyValue(item.editableId,reportEditableTexts[item.editableId]);$event.stopPropagation();"></textarea>
                  <mat-hint align="end">
                    {{ reportEditableTexts[item.editableId]?.length || 0 }}/{{ item.validation.maxLength }}
                  </mat-hint>
                  <mat-hint align="start" *ngIf="reportEditableTexts[item.editableId]?.length > item.validation.maxLength">
                    <font color="red">{{'inspectionReportEditTextDialog.ErrOverMaxLength' | translate}}</font>
                  </mat-hint>
                  <mat-hint align="start" *ngIf="reportEditableTexts[item.editableId]?.length === 0 || reportEditableTexts[item.editableId]?.length === null">
                    <font color="red">{{'inspectionReportEditTextDialog.ErrReq' | translate}}</font>
                  </mat-hint>
                </mat-form-field>
              </ng-container>

              <ng-container *ngIf="!item.validation.required">
                <mat-form-field *ngSwitchCase="'textArea'" class="text-select-form">
                  <mat-label class="top-label">{{ item.label }}</mat-label>
                  <textarea matInput maxlength="{{item.validation.maxLength}}" matTextareaAutosize matAutosizeMinRows=1
                            matAutosizeMaxRows=5 [(ngModel)]="reportEditableTexts[item.editableId]" name="{{item.editableId}}"
                            [errorStateMatcher]="matcher" value="{{reportEditableTexts[item.editableId]}}"
                            ngDefaultControl (focusout)="copyValue(item.editableId,reportEditableTexts[item.editableId]);$event.stopPropagation();"></textarea>
                  <mat-hint align="end">
                    {{ reportEditableTexts[item.editableId]?.length || 0 }}/{{ item.validation.maxLength }}
                  </mat-hint>
                  <mat-hint align="start" *ngIf="reportEditableTexts[item.editableId]?.length > item.validation.maxLength">
                    <font color="red">{{'inspectionReportEditTextDialog.ErrOverMaxLength' | translate}}</font>
                  </mat-hint>
                </mat-form-field>
              </ng-container>
            </ng-container>


            <!-- input type : select and required -->
            <ng-container *ngIf="item.validation.required">
              <mat-form-field *ngSwitchCase="'select'" class="text-select-form">
                <mat-label class="top-label">{{ item.label }}</mat-label>
                <mat-select hideSingleSelectionIndicator [(ngModel)]="reportEditableTexts[item.editableId]" required
                            (selectionChange)="copyValue(item.editableId,reportEditableTexts[item.editableId])">
                  <mat-option *ngFor="let option of item.options" [value]="option.value">
                    {{ option.label }}
                  </mat-option>
                </mat-select>
                <mat-hint align="start" *ngIf="reportEditableTexts[item.editableId]?.length > item.validation.maxLength">
                  <font color="red">{{'inspectionReportEditTextDialog.ErrOverMaxLength' | translate}}</font>
                </mat-hint>
                <mat-hint align="start" *ngIf="reportEditableTexts[item.editableId]?.length === 0 || reportEditableTexts[item.editableId]?.length === null">
                  <font color="red">{{'inspectionReportEditTextDialog.ErrReq' | translate}}</font>
                </mat-hint>
              </mat-form-field>
            </ng-container>

             <!--input type : select and not required-->
            <ng-container *ngIf="!item.validation.required">
              <mat-form-field *ngSwitchCase="'select'" class="text-select-form">
                <mat-label class="top-label">{{ item.label }}</mat-label>
                <mat-select hideSingleSelectionIndicator [(ngModel)]="reportEditableTexts[item.editableId]"
                            (selectionChange)="copyValue(item.editableId,reportEditableTexts[item.editableId])">
                  <mat-option [value]="null">{{'inspectionReportEditTextDialog.NoSelect' | translate}}</mat-option>
                  <mat-option *ngFor="let option of item.options" [value]="option.value">
                    {{ option.label }}
                  </mat-option>
                </mat-select>
                <mat-hint align="start" *ngIf="reportEditableTexts[item.editableId]?.length > item.validation.maxLength">
                  <font color="red">{{'inspectionReportEditTextDialog.ErrOverMaxLength' | translate}}</font>
                </mat-hint>
              </mat-form-field>
            </ng-container>

            <!-- input type : multi select and required -->
            <ng-container *ngIf="item.validation.required">
              <mat-form-field *ngSwitchCase="'multiSelect'" class="text-select-form">
                <mat-label class="top-label">{{ item.label }}</mat-label>
                <mat-select hideSingleSelectionIndicator [(ngModel)]="reportEditableTexts[item.editableId]" required
                            (selectionChange)="copyValue(item.editableId,reportEditableTexts[item.editableId])" multiple>
                  <mat-option *ngFor="let option of item.options" [value]="option.value">
                    {{ option.label }}
                  </mat-option>
                </mat-select>
                <mat-hint align="start" *ngIf="checkMaxLength(reportEditableTexts[item.editableId], item.validation.maxLength)">
                  <font color="red">{{'inspectionReportEditTextDialog.ErrOverMaxLength' | translate}}</font>
                </mat-hint>
                <mat-hint align="start" *ngIf="reportEditableTexts[item.editableId]?.length === 0 || reportEditableTexts[item.editableId]?.length === null">
                  <font color="red">{{'inspectionReportEditTextDialog.ErrReq' | translate}}</font>
                </mat-hint>
              </mat-form-field>
            </ng-container>

            <!-- input type : multi select and not required -->
            <ng-container *ngIf="!item.validation.required">
              <mat-form-field *ngSwitchCase="'multiSelect'" class="text-select-form">
                <mat-label class="top-label">{{ item.label }}</mat-label>
                <mat-select hideSingleSelectionIndicator [(ngModel)]="reportEditableTexts[item.editableId]"
                            (selectionChange)="copyValue(item.editableId,reportEditableTexts[item.editableId])" multiple>
                  <mat-option *ngFor="let option of item.options" [value]="option.value">
                    {{ option.label }}
                  </mat-option>
                </mat-select>
                <mat-hint align="start" *ngIf="checkMaxLength(reportEditableTexts[item.editableId], item.validation.maxLength)">
                  <font color="red">{{'inspectionReportEditTextDialog.ErrOverMaxLength' | translate}}</font>
                </mat-hint>
              </mat-form-field>
            </ng-container>

            <!-- radio group : required -->
            <ng-container *ngIf="item.validation.required">
              <ng-container *ngSwitchCase="'radio'">
                <ng-container *ngIf="radioLists[item.label][item.radioLabel]">
                  <mat-hint align="start">{{ item.label }}</mat-hint>
                  <mat-hint class="mat-hint" align="start" *ngIf="reportEditableTexts[item.editableId]?.length === 0 || reportEditableTexts[item.editableId]?.length === null">
                    <font color="red">{{'inspectionReportEditTextDialog.ErrReq' | translate}}</font>
                  </mat-hint>
                  <br>
                </ng-container>
                <mat-radio-group class="radio-group" [(name)]="item.editableId" [(ngModel)]="reportEditableTexts[item.editableId]"
                                 required (change)="copyValue(item.editableId,reportEditableTexts[item.editableId])">
                  <mat-radio-button class="radio-button" [(checked)]="item.value" [(value)]="item.value">
                    {{ item.radioLabel }}
                  </mat-radio-button>
                </mat-radio-group>
              </ng-container>
            </ng-container>

            <!-- radio group : not required -->
            <ng-container *ngIf="!item.validation.required">
              <ng-container *ngSwitchCase="'radio'">
                <ng-container *ngIf="radioLists[item.label][item.radioLabel]">
                  <mat-hint class="mat-hint" align="start">{{ item.label }}</mat-hint>
                  <br>
                </ng-container>
                <mat-radio-group class="radio-group" [(name)]="item.editableId" [(ngModel)]="reportEditableTexts[item.editableId]"
                                 (change)="copyValue(item.editableId,reportEditableTexts[item.editableId])">
                  <mat-radio-button class="radio-button" [(checked)]="item.value" [(value)]="item.value">
                    {{ item.radioLabel }}
                  </mat-radio-button>
                </mat-radio-group>
              </ng-container>
            </ng-container>

            <!-- date : required -->
            <ng-container *ngIf="item.validation.required">
              <mat-form-field *ngSwitchCase="'date'" class="datepicker">
                <mat-label class="top-label">{{ item.label }}</mat-label>
                <input matInput [min]="minDate" [max]="maxDate" [matDatepicker]="picker" [(ngModel)]="reportEditableTexts[item.editableId]"
                       name="{{item.editableId}}" ngDefaultControl required readonly (dateChange)="copyValue(item.editableId,reportEditableTexts[item.editableId])">
                <mat-datepicker-toggle matSuffix [for]="picker">
                  <mat-icon class="datepicker-icon" matDatepickerToggleIcon>today</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-hint align="start" *ngIf="reportEditableTexts[item.editableId]?.length === 0 || reportEditableTexts[item.editableId]?.length === null">
                  <font color="red">{{'inspectionReportEditTextDialog.ErrReq' | translate}}</font>
                </mat-hint>
              </mat-form-field>
            </ng-container>

            <!-- date : not required -->
            <ng-container *ngIf="!item.validation.required">
              <mat-form-field *ngSwitchCase="'date'" class="datepicker">
                <mat-label class="top-label">{{ item.label }}</mat-label>
                <input matInput [min]="minDate" [max]="maxDate" [matDatepicker]="picker" [(ngModel)]="reportEditableTexts[item.editableId]"
                       name="{{item.editableId}}" ngDefaultControl readonly (dateChange)="copyValue(item.editableId,reportEditableTexts[item.editableId])">
                <mat-datepicker-toggle matSuffix [for]="picker">
                  <mat-icon class="datepicker-icon" matDatepickerToggleIcon>today</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</mat-dialog-content>

<div fxLayout="row wrap" fxLayoutAlign="center">
  <mat-dialog-actions>
    <button mat-button (click)="close()" color="primary">{{'inspectionReportEditTextDialog.Close' | translate}}</button>
    <button mat-raised-button (click)="submit(reportEditableTexts, inputGroups, true)" color="primary" [disabled]="!isEditableItems || !isValueChange || isProcess">{{'inspectionReportEditTextDialog.Save' | translate}}</button>
  </mat-dialog-actions>
</div>
